module.exports = __webpack_public_path__ + "static/media/call-me-hand-svgrepo-com.334efc21.svg";